'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getUrlWithSize } from '../../../../utils/urls';

class RealtyItem extends Component {
  render () {
    const {url, photo, photoAlt, header, body, footer} = this.props;

    return (
      <div className='popup-realty-item'>
        <a className='link' href={url} target='_blank'>
          <table>
            <tr>
              <td>
                {
                  photo
                    ? <img className='photo' src={getUrlWithSize(photo, '120x120')} alt={photoAlt} />
                    : <div className='no-photo'>нет фото</div>
                }
              </td>
              <td className='text-align-top'>
                <div className='content'>
                  <div className='header'>{header}</div>
                  <div className='body'>{body}</div>
                  <div className='footer'>{footer}</div>
                </div>
              </td>
            </tr>
          </table>
        </a>
      </div>
    );
  }
}

export const itemProps = {
  url: PropTypes.string,
  photo: PropTypes.string,
  photoAlt: PropTypes.string,
  header: PropTypes.string,
  body: PropTypes.string,
  footer: PropTypes.string
};

RealtyItem.propTypes = itemProps;

RealtyItem.defaultProps = {
  url: '#',
  photo: '',
  photoAlt: '',
  header: '',
  content: '',
  footer: ''
};

export default RealtyItem;



// WEBPACK FOOTER //
// ./src/ui/Maps/Controls/Popup/RealtyItem.jsx